export default __webpack_public_path__ + "static/media/delete-ticket.37caa5ca.svg";